export const ERROR_NAME = 'MissingDataError'

export class MissingDataError extends Error {
  constructor(dataType, componentName) {
    const errorSource = componentName
      ? `\`${componentName}\``
      : 'a child component'
    const message = `${dataType} data required by ${errorSource} is missing or invalid`
    super(message)
    this.name = ERROR_NAME
    this.dataType = dataType
    this.component = componentName
  }
}

export default MissingDataError
